import React from "react";
import { DatePicker } from "antd";
import ptBR from "antd/es/date-picker/locale/pt_BR";
import { disableWeekends } from "@utils/FormatDate";

const InputDatePickerComp = React.forwardRef(
  (
    {
      label,
      name,
      value,
      error,
      className,
      hoverMessage,
      required,
      disabled,
      showTime,
      onChange,
      placeholder,
      ...rest
    },
    ref
  ) => {

    return (
      <div className="row mb-1" title={hoverMessage}>
        <label htmlFor={name} className="col-auto col-form-label">
          {label}
        </label>
        <div className="col-auto">

          <DatePicker
            id={name}
            name={name}
            ref={ref}
            className={`form-control text dark ${className ?? ""}`}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            required={required}
            style={{
              fontSize: "14px",
              fontFamily: 'Montserrat',
              height: "2.375rem",
              lineHeight: "1.5",
            }}
            locale={ptBR}
            disabled={disabled}
            allowClear={true}
            showTime={showTime}
            disabledDate={disableWeekends}
            {...rest}
          />
        </div>

        {/* Exibição da mensagem de erro */}
        {error && <p className="text-danger mt-2">{error.message}</p>}
      </div>
    );
  }
);

export default React.memo(InputDatePickerComp);

